import {API_BASE_URL} from './Settings';

export async function getDashboardStats() {
    const savedFirm = localStorage.getItem('selectedFirm');
    const firm = savedFirm ? JSON.parse(savedFirm) : null;

    const savedUser = localStorage.getItem('user');
    const user = savedUser ? JSON.parse(savedUser).user : null;

    const response = await fetch(`${API_BASE_URL}/dashboard?firmIdt=${firm.idt}&userIdt=${user.idt}`);
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}
